module.exports = __webpack_public_path__ + "img/sv7.5c265fbf.svg";